import { Component, Input, Output, EventEmitter, Optional } from '@angular/core';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';
import { NgForm, FormGroup, FormGroupDirective } from '@angular/forms';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'link';
export type ButtonSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss'],
})
export class CustomButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() icon: string | null = null;
  @Input() type: 'button' | 'submit' = 'button';
  @Input() block = false;
  @Input() hidden = false;

  @Input() modalClose?: { ref: any; prop: string };
  @Input() confirmClose = false;
  @Input() formRef?: FormGroup | NgForm;
  @Input() skipDirtyCheck = false;
  @Input() skipFormCheck = false;


  @Output() btnClick = new EventEmitter<MouseEvent>();

  get buttonClasses(): string {
    const classes = ['custom-btn', `custom-btn--${this.variant}`, `custom-btn--${this.size}`];
    if (this.block) classes.push('custom-btn--block');
    if (this.loading) classes.push('custom-btn--loading');
    return classes.join(' ');
  }

  constructor(
    @Optional() private confirmation: ConfirmationService,
  ) {}

  onClick(event: MouseEvent): void {
    if (this.disabled || this.loading) return;

    if (this.modalClose || this.confirmClose) {
      this.handleModalClose();
      return;
    }

    this.btnClick.emit(event);
  }

  private handleModalClose(): void {
    const form = this.formRef;
    const isDirty = form instanceof FormGroup
      ? form.dirty
      : form instanceof NgForm
        ? form.dirty
        : false;

    if (this.confirmClose && !this.skipDirtyCheck && (this.skipFormCheck || isDirty) && this.confirmation) {
      this.confirmation
        .warn('::YouHaveUnsavedChanges', 'AbpUi::AreYouSure', {
          yesText: 'AbpUi::Yes',
          cancelText: 'AbpUi::Cancel',
        })
        .subscribe((status: Confirmation.Status) => {
          if (status === Confirmation.Status.confirm) {
            this.closeModal();
          }
        });
    } else {
      this.closeModal();
    }
  }

  private closeModal(): void {
    if (this.modalClose) {
      this.modalClose.ref[this.modalClose.prop] = false;
    }
    this.btnClick.emit();
  }
}